import gql from 'graphql-tag';

export const UPSERT_DEAL_BUILDER_EQUIPMENTS = gql`
  mutation UpsertDealBuilderEquipments($input: UpsertDealBuilderEquipmentsInput!) {
    dealBuilder {
      upsertDealBuilderEquipments(input: $input) {
        success
        error
        entity {
          proposalEquipmentsId
          proposalId
          equipmentId
        }
      }
    }
  }
`;
